// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MGOK1","footer":"styles_footer__xSafN","passCodeTooltip":"styles_passCodeTooltip__3YKWs"};